import React, { FC } from 'react';

import { Checkbox } from '../../../../../../shared/components';
import { i18n } from '../../../../../../shared/helpers/i18n';
import css from './styles.css';

export interface SummarizationMailRecipientCheckboxProps {
    checked?: boolean;
    disabled?: boolean;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

export const SummarizationMailRecipientCheckbox: FC<SummarizationMailRecipientCheckboxProps> = (props) => {
    return (
        <Checkbox
            {...props}
            className={css.checkbox}
            label={i18n('summarization', 'send-summary-to-participants')}
            size="md"
            view="orb"
        />
    );
};
